export const NEW_CHAT_MESSAGE = "chat.message.new";
export const NEW_CHAT = "chat.new";
export const CHAT_ADMIN_ASSIGNED = "chat.admin.assigned";
export const CHAT_STATUS_CHANGED = "chat.status.changed";

export const DEVICE_LOGOUT = "device_logout";

